import { MissRowFrame, UserAnswer } from '@/components/practice/SharedMissRow';

import type { MissRowProps } from '../types';

import type { SubstantivoPayload } from './types';

/**
 * The shared row would print the noun's meaning, and the mistake was the
 * gender. Same reasoning as Der·Die·Das, which overrides this for the same
 * reason.
 */
export function MissRow({ card, user_answer }: MissRowProps<SubstantivoPayload>) {
  return (
    <MissRowFrame>
      <div className="flex flex-col gap-0.5">
        <span className="font-display text-lg">
          <span className={card.payload.article === 'o' ? 'text-masculine' : 'text-feminine'}>
            {card.payload.article}
          </span>{' '}
          {card.de}
        </span>
        <UserAnswer user_answer={user_answer} verb="chose" />
      </div>
    </MissRowFrame>
  );
}
